/* Sad Nuggie: Fryer Board (Halloween summoning matchmaker). Used by sections/sn-fryer-board.liquid */
(function () {
  var root = document.querySelector('.snoj');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var board = $('.board'), pl = $('.pl'), sayLabel = $('.say small'), sayText = $('.say .txt'), caret = $('.say i');
  var yesBtn = $('.yn.yes'), noBtn = $('.yn.no'), bye = $('.bye'), table = $('.table'), penta = $('.penta'), cult = $('.cult');
  var idleBox = $('.ctl .idle'), hint = $('.ctl .hint'), veil = $('.veil');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- the pool: in stock Nuggies only ---------- */
  var TRAITS = [ /* keyword in the product title, cuddly, spooky, chaos, big */
    ['halloween cat', 0, 1, 1, 0], ['black cat', 0, 1, 0, 0], ['brown cat', 1, 0, 0, 0], ['red panda', 1, 0, 1, 0], ['fire horse', 0, 0, 1, 1],
    ['blue dragon', 0, 1, 1, 1], ['dress up', 1, 0, 0, 0], ['giraffe', 1, 0, 0, 1], ['monkey', 1, 0, 1, 0], ['dino', 0, 0, 1, 1],
    ['reindeer', 1, 0, 0, 1], ['chicken', 1, 0, 1, 1], ['devil', 0, 1, 1, 1], ['raccoon', 0, 0, 1, 0], ['spider', 0, 1, 0, 0],
    ['pickle', 0, 0, 1, 0], ['mystery', 1, 1, 0, 0], ['elephant', 1, 0, 0, 0], ['duck', 1, 0, 1, 0], ['fox', 0, 0, 1, 0],
    ['shark', 0, 1, 1, 1], ['capybara', 1, 0, 0, 1], ['cat', 1, 0, 1, 0], ['bee', 1, 0, 1, 0], ['cow', 1, 0, 0, 1],
    ['unicorn', 1, 0, 0, 0], ['frog', 0, 0, 1, 0], ['sloth', 1, 0, 0, 0], ['bunny', 1, 0, 0, 0], ['axolotl', 1, 0, 1, 0],
    ['dragon', 0, 1, 1, 1], ['panda', 1, 0, 0, 1], ['owl', 0, 1, 0, 0], ['llama', 1, 0, 1, 1], ['bat', 0, 1, 1, 0],
    ['pumpkin', 1, 1, 0, 0], ['werewolf', 0, 1, 1, 0], ['original', 1, 0, 0, 0]
  ];
  var DROP = { sad: 1, nuggie: 1, nuggies: 1, plush: 1, plushie: 1, limited: 1, edition: 1, vault: 1, shoulder: 1, pal: 1, mini: 1, keychain: 1, preorder: 1, pre: 1, order: 1, collector: 1, the: 1, rare: 1 };
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0) / 4294967295; }
  function buildPool() {
    var raw = [], hold = (root.dataset.hold || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var minis = root.dataset.minis === 'true', seen = {};
    try { raw = JSON.parse(document.getElementById('snoj-data').textContent) || []; } catch (e) { raw = []; }
    var out = [];
    raw.forEach(function (p) {
      if (!p || !p.h || seen[p.h] || hold.indexOf(p.h) >= 0) return;
      var t = (p.t || '').toLowerCase(), g = '|' + (p.g || '') + '|';
      if ((p.y || '').toLowerCase() !== 'plushie') return;
      if (/outfit|accessory|blind box|bundle|pouch|backpack|adoption video|auction/.test(t)) return;
      if (g.indexOf('|outfits|') >= 0 || g.indexOf('|botf|') >= 0 || g.indexOf('|blind box|') >= 0) return;
      var isMini = /\bmini\b|keychain/.test(t) || g.indexOf('|mini plush|') >= 0;
      if (isMini && !minis) return;
      seen[p.h] = 1;
      var words = t.replace(/[^a-z ]/g, ' ').split(/\s+/).filter(function (w) { return w && !DROP[w]; }).slice(0, 2);
      var spell = words.join(' ').toUpperCase() || 'NUGGIE';
      var nice = words.map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
      var pal = /shoulder pal/.test(t);
      var name = pal ? nice + ' Shoulder Pal' : (isMini ? 'Mini ' + nice + ' Nuggie' : nice + ' Nuggie');
      var tr = null;
      for (var i = 0; i < TRAITS.length; i++) { if (t.indexOf(TRAITS[i][0]) >= 0) { tr = TRAITS[i]; break; } }
      if (!tr) tr = ['', hash(p.h + 'c') < 0.5 ? 1 : 0, hash(p.h + 's') < 0.35 ? 1 : 0, hash(p.h + 'x') < 0.5 ? 1 : 0, hash(p.h + 'b') < 0.5 ? 1 : 0];
      out.push({ id: p.h, spell: spell, name: name, url: p.u, img: p.i || '', mystery: /mystery/.test(t), cuddly: tr[1], spooky: tr[2], chaos: tr[3], big: (pal || isMini) ? 0 : tr[4] });
    });
    return out;
  }
  var POOL = buildPool();

  /* ---------- the board ---------- */
  function pos(ch) {
    var top = 'ABCDEFGHIJKLM', bot = 'NOPQRSTUVWXYZ', num = '1234567890', i;
    if ((i = top.indexOf(ch)) >= 0) return { x: 10 + i * (80 / 12), y: 43 - 13 * Math.sin(Math.PI * i / 12) };
    if ((i = bot.indexOf(ch)) >= 0) return { x: 10 + i * (80 / 12), y: 62 - 13 * Math.sin(Math.PI * i / 12) };
    if ((i = num.indexOf(ch)) >= 0) return { x: 27.5 + i * 5, y: 78 };
    if (ch === 'YES') return { x: 13, y: 13 };
    if (ch === 'NO') return { x: 87, y: 13 };
    return { x: 50, y: 72 };
  }
  var cells = {};
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('').forEach(function (ch) {
    var p = pos(ch), el = document.createElement('span');
    el.className = 'lt' + (/[0-9]/.test(ch) ? ' num' : ''); el.textContent = ch;
    el.style.left = p.x.toFixed(2) + '%'; el.style.top = p.y.toFixed(2) + '%';
    board.insertBefore(el, bye); cells[ch] = el;
  });
  var hotEl = null;
  function hot(el) { if (hotEl) hotEl.classList.remove('hot'); hotEl = el || null; if (hotEl) hotEl.classList.add('hot'); }
  function move(x, y, rot) { pl.style.left = x + '%'; pl.style.top = y + '%'; pl.style.transform = 'translate(-50%,-58.7%) rotate(' + (rot || 0) + 'deg)'; }
  function say(t) { sayText.textContent = t; }
  function setHint(html) { idleBox.hidden = true; hint.hidden = false; hint.innerHTML = html; }
  function summonFx(on) { [table, penta, cult].forEach(function (el) { if (el) el.classList.toggle('summon', !!on); }); }

  /* ---------- decks: nothing repeats until every option has been used ---------- */
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  var decks = {}, lastDraw = {};
  function draw(name, a) { var d = decks[name]; if (!d || !d.length) { d = shuffle(a); if (lastDraw[name] === d[d.length - 1] && d.length > 1) d.unshift(d.pop()); decks[name] = d; } var v = d.pop(); lastDraw[name] = v; return v; }

  var BANK = {
    cuddly: [['CUDDLY', 1, 'do you want a cuddly one?'], ['HUGS', 1, 'are you a hugger?'], ['SOFTIE', 1, 'do you want a big softie?'], ['CLINGY', 1, 'can it be clingy?'], ['SNUGGLES', 1, 'bedtime snuggles?'], ['LONER', 0, 'do you want a loner who needs space?'], ['TOUGH', 0, 'do you want a tough one?'], ['GRUMPY', 0, 'can it be a grump?']],
    spooky: [['SPOOKY', 1, 'should it be spooky?'], ['CREEPY', 1, 'do you like them creepy?'], ['HAUNTED', 1, 'should it be a little haunted?'], ['CURSED', 1, 'is a small curse okay?'], ['DARK', 1, 'do you like the dark side?'], ['SWEET', 0, 'should it be pure and sweet?'], ['SUNNY', 0, 'do you want a sunny one?'], ['ANGEL', 0, 'do you want a little angel?']],
    chaos: [['CHAOS', 1, 'can you handle chaos?'], ['TROUBLE', 1, 'do you want a troublemaker?'], ['WILD', 1, 'should it be wild?'], ['LOUD', 1, 'can it be loud?'], ['FERAL', 1, 'a bit feral?'], ['MENACE', 1, 'do you want a tiny menace?'], ['CALM', 0, 'do you want a calm one?'], ['SLEEPY', 0, 'do you want a sleepy one?'], ['GENTLE', 0, 'should it be gentle?'], ['QUIET', 0, 'do you want a quiet one?']],
    big: [['BIG', 1, 'do you want a big one?'], ['TALL', 1, 'should it be tall?'], ['CHONKY', 1, 'do you want a chonky one?'], ['TINY', 0, 'do you want a tiny one?'], ['POCKET', 0, 'should it fit in your pocket?'], ['SMOL', 0, 'do you want a smol one?']]
  };
  var GREET = ['HELLO', 'BOO', 'HI HUMAN', 'WHO DARES', 'I AWAKEN', 'OH ITS YOU', 'HUNGRY', 'SPEAK', 'GREETINGS', 'WE HEAR YOU'];
  var YES = ['GOOD', 'OOH', 'YESSS', 'BRAVE', 'NOTED', 'I KNEW IT', 'BOLD', 'HEHE', 'NICE'];
  var NO = ['HMM', 'I SEE', 'RUDE', 'FINE', 'NOTED', 'OH NO', 'WISE', 'BORING', 'OK OK'];
  var TEASE = ['I SEE IT', 'FOUND ONE', 'IT COMES', 'BEHOLD', 'YOURS IS', 'IT WAKES', 'FRYER SAYS', 'AH YES', 'THIS ONE'];
  var LINES = ['The Sad Nuggie spirits have spoken.', 'The Sad Nuggie spirits have matched you with your perfect Nuggie.', 'The Sad Nuggie spirits have chosen. There is no going back.', 'The fryer has spoken. This one is yours.', 'The Sad Nuggie spirits searched the fryer and found your match.', 'The spirits are never wrong. Meet your perfect Nuggie.'];
  var MYSTERY_LINE = 'The spirits are having a tough time matching you to just one Nuggie. They recommend a mystery Nuggie.';

  /* ---------- a session ---------- */
  var run = 0, timer = null, phase = 'idle', qs = [], qi = 0, answers = {}, seen = [];
  function later(fn, ms) { var r = run; timer = setTimeout(function () { if (r === run) fn(); }, reduce ? Math.min(ms, 120) : ms); }
  function spell(word, done, slow) {
    var i = 0, said = '', step = slow ? 600 : 400;
    (function next() {
      if (i >= word.length) { hot(null); later(done, 300); return; }
      var ch = word[i++];
      if (ch === ' ') { said += ' '; say(said); hot(null); later(next, 260); return; }
      var p = pos(ch); move(p.x, p.y, (p.x - 50) * 0.5); hot(null);
      later(function () { said += ch; say(said); hot(cells[ch]); later(next, step - 320); }, 320);
    })();
  }
  function setPhase(p) { phase = p; yesBtn.classList.toggle('live', p === 'answer'); noBtn.classList.toggle('live', p === 'answer'); pl.classList.toggle('idle', p === 'idle' || p === 'answer'); }
  function begin() {
    run++; clearTimeout(timer); answers = {};
    qs = shuffle(Object.keys(BANK)).slice(0, 3).map(function (k) { var w = draw('q-' + k, BANK[k]); return { key: k, word: w[0], pol: w[1], text: 'The spirits ask: ' + w[2] }; });
    setPhase('busy'); sayLabel.textContent = 'The spirits say'; say(''); setHint('The board is waking up...');
    later(function () { spell(draw('greet', GREET), function () { question(0); }); }, 500);
  }
  function question(i) {
    if (i >= qs.length) { summon(); return; }
    qi = i; setPhase('busy'); say(''); setHint('The spirits have a question...');
    later(function () { spell(qs[i].word, function () {
      say(qs[i].word + '?'); move(50, 72, 0); setPhase('answer');
      setHint(qs[i].text + ' Tap <em>YES</em> or <em>NO</em> on the board.');
    }); }, 350);
  }
  function answer(yes) {
    if (phase !== 'answer') return;
    var q = qs[qi], p = pos(yes ? 'YES' : 'NO');
    answers[q.key] = yes ? q.pol : 1 - q.pol;
    setPhase('busy'); setHint('The spirits are listening...'); move(p.x, p.y + 9, yes ? -14 : 14); hot(yes ? yesBtn : noBtn);
    later(function () { say(''); setHint('The spirits react...');
      spell(draw(yes ? 'yes' : 'no', yes ? YES : NO), function () { later(function () { question(qi + 1); }, 450); });
    }, 800);
  }
  function match() {
    var seed = String(Math.random()), best = null;
    var pool = POOL.filter(function (n) { return seen.indexOf(n.id) < 0; }); if (!pool.length) pool = POOL;
    pool.forEach(function (n) {
      var score = hash(seed + '|' + n.id) * 1.6;
      ['cuddly', 'spooky', 'chaos', 'big'].forEach(function (t) { if (answers[t] !== undefined) score += (n[t] === answers[t]) ? 1.5 : -1; });
      if (!best || score > best.score) best = { n: n, score: score };
    });
    return best ? best.n : null;
  }
  function summon() {
    var n = match() || { id: 'none', spell: 'MYSTERY', name: 'Mystery Nuggie', url: root.dataset.fallback || '/', img: '', mystery: true };
    seen = seen.concat([n.id]).slice(-Math.min(4, Math.max(0, POOL.length - 1)));
    setPhase('busy'); say(''); hot(null); setHint('The spirits are searching the fryer...');
    later(function () { spell(draw('tease', TEASE), function () {
      say(''); setHint('Summoning your Nuggie...'); summonFx(true);
      later(function () { spell(n.spell, function () { summonFx(false); reveal(n); }, true); }, 700);
    }); }, 500);
  }
  function reveal(n) {
    setPhase('reveal'); caret.hidden = true;
    var ph = $('.card .ph');
    ph.innerHTML = '';
    if (n.img) { var im = document.createElement('img'); im.src = n.img; im.alt = n.name; ph.appendChild(im); }
    $('.card h2').textContent = n.name;
    $('.card p').textContent = n.mystery ? MYSTERY_LINE : draw('line', LINES);
    var a = $('.card .adopt'); a.href = n.url; a.textContent = 'Adopt ' + n.name;
    veil.hidden = false;
    a.focus({ preventScroll: true });
    var r = veil.querySelector('.card').getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) veil.querySelector('.card').scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }
  function reset() {
    run++; clearTimeout(timer); summonFx(false); hot(null); veil.hidden = true; caret.hidden = false;
    sayLabel.textContent = 'The board is sleeping'; say(''); move(50, 72, 0); setPhase('idle'); hint.hidden = true; idleBox.hidden = false;
  }
  $('.wake').addEventListener('click', begin);
  yesBtn.addEventListener('click', function () { answer(true); });
  noBtn.addEventListener('click', function () { answer(false); });
  $('.card .again').addEventListener('click', reset);
  reset();
})();
